import { EyeIcon, EyeSlashIcon } from "./icons";
import { inputBase, labelBase } from "./styles";

export default function OwnerSection({
  form,
  onChange,
  showPassword,
  setShowPassword,
}) {
  return (
    <section className="rounded-3xl border border-slate-200 bg-slate-50/60 p-5">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-slate-900">Owner user</h2>
        <span className="text-xs rounded-full border border-indigo-200 bg-indigo-50 px-2 py-1 text-indigo-700">
          Stored second
        </span>
      </div>

      <div className="mt-5 grid gap-4">
        <div className="grid gap-2">
          <label className={labelBase}>Owner email</label>
          <input
            name="email"
            type="email"
            required
            className={inputBase}
            value={form.email}
            onChange={onChange}
            placeholder="owner@clinic.com"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <PasswordField
            label="Password"
            name="password"
            value={form.password}
            onChange={onChange}
            showPassword={showPassword}
            toggle={() => setShowPassword((p) => !p)}
          />

          <PasswordField
            label="Confirm password"
            name="confirm_password"
            value={form.confirm_password}
            onChange={onChange}
            showPassword={showPassword}
            toggle={() => setShowPassword((p) => !p)}
          />
        </div>
      </div>
    </section>
  );
}

function PasswordField({ label, name, value, onChange, showPassword, toggle }) {
  return (
    <div className="grid gap-2">
      <label className={labelBase}>{label}</label>

      <div className="relative">
        <input
          name={name}
          type={showPassword ? "text" : "password"}
          required
          className={`${inputBase} pr-11`}
          value={value}
          onChange={onChange}
          placeholder="••••••••"
        />

        <button
          type="button"
          onClick={toggle}
          className="absolute inset-y-0 right-1.5 my-1.5 inline-flex items-center justify-center rounded-lg px-2 text-indigo-600 hover:text-indigo-700 hover:bg-indigo-50"
          aria-label={showPassword ? "Hide password" : "Show password"}
        >
          {showPassword ? <EyeSlashIcon /> : <EyeIcon />}
        </button>
      </div>
    </div>
  );
}
